import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { Component, ViewChild } from '@angular/core';

import {
    ScriptLoaderService, ClassService
} from '../../../../../_services';
import { Investor, INVESTOR_INCLUDES } from '../../../../../_models';
import { InvestorFormComponent } from '../investor-form';
import { BooleanSwitchComponent } from '../../../../../shared/boolean-switch';
import { DatePickerComponent } from '../../../../../shared/date-picker';

@Component({
    selector: 'app-investor-form',
    templateUrl: '../investor-form/investor-form.component.html',
    styleUrls: ['../investor-form/investor-form.component.scss']
})
export class InvestorEditComponent extends InvestorFormComponent {
    formHeader = {
        icon: 'fa fa-user',
        text: 'EDITAR PROPIETARIO'
    }
    investorId: number;
    @ViewChild(BooleanSwitchComponent) nationalitySwitch: BooleanSwitchComponent;
    @ViewChild(DatePickerComponent) datepicker: DatePickerComponent;
    constructor(private _scriptEdit: ScriptLoaderService,
        private _locationEdit: Location, fbEdit: FormBuilder,
        private _classServiceEdit: ClassService,
        private route: ActivatedRoute, private routerEdit: Router,
        private _investorData: Investor
    ) {
        super(_scriptEdit, _locationEdit, fbEdit, _classServiceEdit,
            routerEdit, _investorData);
        this.investorId = this.route.snapshot.params['id'];
        this.form.valueChanges.subscribe(formValue => {
            if (this.form.valid) {
                // console.log(formValue);
                this.requests$ = this.investorData.put(this.investorId, formValue);
            }
        });
        this.dataFetched = false;
        this.investorData.get(this.investorId, `include=${INVESTOR_INCLUDES}`)
            .subscribe(investor => {
                this.form.setValue(investor.pick(this.form.value));
                this.nationalitySwitch.setState(this.form.value.is_foreign);
                this.datepicker.setDate(this.form.value.dob);
                this.dataFetched = true;
            })
    }

    end() {
        if (this.investorId)
            this.router.navigate([`/investors/${this.investorId}`]);
    }
}



// WEBPACK FOOTER //
// /Users/cmedina/Code/motto_frontend/src/app/theme/pages/aside-left-display-disabled/investor/investor-edit/investor-edit.component.ts